export const breakpoints = {
  sm: "37.5rem", // 600px
  md: "56.25rem", // 900px
  lg: "75rem", // 1200px
  xl: "96rem", // 1536px
}
